export class EditAuditLocationLocation{
    public AuditID:number;
    public LocationID:number;
    public LocationName:string;
    public LocationLevelSeq:number = -1;
    public ParentID:number = -1;
    public AssignedToAudit:boolean = false;
    public TopLevel:boolean = false;
   
    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}